<script>
  import HomePage from '$lib/pages/HomePage.svelte';
</script>

<HomePage />
